"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _activationCode = require("@/api/activationCode");
var _qrcode = _interopRequireDefault(require("qrcode.vue"));
var _lifehikesInitData = require("@/lifehikes-init-data");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _lodash = _interopRequireDefault(require("lodash"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import moment from 'moment'
var _default = exports.default = {
  name: "LoopCode",
  components: {
    QrcodeVue: _qrcode.default
  },
  props: {
    parentId: {
      type: String,
      default: ""
    },
    internalTitle: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      codeImg: null,
      dialogVisible: false,
      codeDialogVisible: false,
      limitDialogVisible: false,
      loading: false,
      codeList: [],
      originalCodeList: [],
      errorMsg: "",
      errorStyle: "",
      disableGenButton: false,
      form: {
        loop: "",
        numberOfCodes: 0,
        userLimit: 0
      }
    };
  },
  created() {
    if (this.parentId !== "copy") {
      this.form.loop = this.parentId;
      this.getCode();
    }
  },
  methods: {
    openDialogBox() {
      // this.$refs.qrcode.open()
      this.dialogVisible = true;
      this.errorMsg = "";
      this.form.userLimit = 1;
      this.form.numberOfCodes = 1;
      this.disableGenButton = false;
    },
    genCode() {
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      const oEmail = (0, _cookie.getCookie)("EMAIL");

      // console.log('gencode-form', this.form)

      (0, _activationCode.generateCode)(token, this.form).then(response => {
        this.codeList = this.codeList.concat(response.data);
        (0, _ga.writeGaEvent)(this, "Loop", `${_lifehikesInitData.userEvent.loop.generateCode}`, oEmail, `Loop Id: ${this.form.loop}`);
        this.errorMsg = `Error : Fail to generate the code`;
        this.errorStyle = "color:#67C23A";
        this.disableGenButton = true;
        this.getCode();
        this.dialogVisible = false;
        const msg = `QR code is generated successfully`;
        (0, _log.displayPopupMessage)(msg, "success");
      }).catch(error => {
        (0, _log.showDebugLog)("GenerateCode-API-error", error);
        this.errorMsg = `Error : Fail to generate the code`;
        this.errorStyle = "color:#F56C6C";
        (0, _log.displayPopupMessage)(this.errorMsg, "error");
      });
    },
    getCode() {
      const id = this.form.loop;
      // console.log('hikeID', id)
      if (!id) return;
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      const query = {
        page: 1,
        limit: 100,
        sort: "status",
        loop: id
      };
      this.loading = true;
      (0, _activationCode.getCodeList)(token, query).then(response => {
        this.loading = false;
        (0, _log.showDebugLog)("loop-Code-Search-response", response);
        this.codeList = _lodash.default.cloneDeep(response.data.rows);
        this.originalCodeList = _lodash.default.cloneDeep(response.data.rows);
      }).catch(error => {
        (0, _log.showDebugLog)("loop-code-search-api-error", error);
        this.loading = false;
        (0, _log.displayPopupMessage)(error, "error");
      });
    },
    updateLimit(c, index) {
      const token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      const oEmail = (0, _cookie.getCookie)("EMAIL");
      var body = {
        userLimit: c.userLimit
      };
      if (this.originalCodeList[index].userLimit >= c.userLimit) {
        (0, _log.displayPopupMessage)("Reuse value cannot be smaller than before", "error");
        return;
      }
      (0, _activationCode.updateCode)(token, c.id, body).then(response => {
        (0, _ga.writeGaEvent)(this, "Loop", `${_lifehikesInitData.userEvent.loop.updateCode}`, oEmail, `Loop Id: ${c.loop}`);
        this.getCode();
        (0, _log.displayPopupMessage)("QR Code is updated", "success");
      }).catch(error => {
        (0, _log.showDebugLog)("loop-code-updatelimit-api-error", error);
        (0, _log.displayPopupMessage)("Fail to update QR code", "error");
      });
    },
    showQRCodePath(code) {
      return _lifehikesInitData.qrPrefix + code;
    },
    async printCode(idx) {
      const el = this.$refs.displayCode;
      this.codeDialogVisible = true;

      // console.log('element', el)

      const options = {
        type: "dataURL"
      };
      this.codeImg = await this.$html2canvas(el[idx], options);
      // console.log('base64', this.codeImg)
    }
  }
};